import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import classnames from "classnames";

type TTemplatesProps = {
  activeIndex: number;
  templateMessages: any[];
  onItemClick: (item: string) => void;
  numberOfMultipleItems: number;
  onItemChange: (index: number) => void;
}

const Templates = ({ activeIndex, templateMessages, onItemClick, numberOfMultipleItems, onItemChange }: TTemplatesProps) => {

  // Function that truncates the text
  const truncateText = (text: string) => {
    return text.length > 100 ? text.substring(0, 100) + "..." : text;
  }

  return (
    <Carousel
      showThumbs={false}
      showStatus={false}
      showArrows={false}
      showIndicators={false}
      centerSlidePercentage={100 / (numberOfMultipleItems > templateMessages.length ? templateMessages.length : numberOfMultipleItems)}
      centerMode
      selectedItem={activeIndex}
      onClickItem={(item) => {
        onItemChange(item)
      }}
    >
      {templateMessages.map((item, idx) => {
        return (
          <div key={idx}>
            <div className={classnames("carousel-item-template", { "me-3 ms-1": numberOfMultipleItems !== 1 })} onClick={() => onItemClick(item.content || item)}>{truncateText(item.content || item)}</div>
          </div>
        )
      })}
    </Carousel>
  )
}

export default Templates;